import { render, staticRenderFns } from "./PriceOverview.vue?vue&type=template&id=0929b19d&scoped=true&"
import script from "./PriceOverview.vue?vue&type=script&lang=ts&"
export * from "./PriceOverview.vue?vue&type=script&lang=ts&"
import style0 from "./PriceOverview.vue?vue&type=style&index=0&id=0929b19d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0929b19d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VImg,VRow})
